import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  SiteContext,
  selectIsBonusCampaignsEnabled,
  selectIsJackpotsEnabled,
} from '@homeplay/app';
import JackpotBanner from '../JackpotBanner';
import bonusCampaignsBanner from '../../../../shared/assets/images/bonus-campaigns/deposit-bonus-banner.png';
import classes from './PromoBanners.module.scss';

const PromoBanners = ({ jackpotImage }) => {
  const { siteName } = useContext(SiteContext);
  const isJackpotsEnabled = useSelector(selectIsJackpotsEnabled);
  const isBonusCampaignsEnabled = useSelector(selectIsBonusCampaignsEnabled);
  const basePath = `/${siteName ? siteName + '/' : ''}`;

  if (!isBonusCampaignsEnabled) {
    return isJackpotsEnabled ? <JackpotBanner image={jackpotImage} /> : null;
  }

  return (
    <div className={classes.PromoBanners}>
      {isJackpotsEnabled && jackpotImage && (
        <Link to={`${basePath}jackpot`} className={classes.Banner}>
          <img src={jackpotImage} alt="Jackpot" />
        </Link>
      )}
      <Link to={`${basePath}promo`} className={classes.Banner}>
        <img src={bonusCampaignsBanner} alt="Deposit Bonus" />
      </Link>
    </div>
  );
};

export default React.memo(PromoBanners);
